import React from 'react';
import FlexBox from './FlexBox';
import ContentText from '@solid-ui-components/ContentText';
import { Box } from 'theme-ui';
import { combineText } from '../../../functions/combineText';

interface InstructionsProps {
  staticContent: any;
  dynamicContent: {
    kicker?: {
      text: string;
      inject: string[];
    };
    title: {
      text: string;
      inject?: string[];
    };
    step1: {
      title: string;
      description: string;
      inject?: string[];
    };
    step2: {
      title: string;
      description: string;
      inject?: string[];
    };
    step3: {
      title: string;
      description: string;
      inject?: string[];
    };
  };
}

const Instructions: React.FC<InstructionsProps> = ({
  dynamicContent,
  staticContent,
}) => {
  if (
    !(
      (staticContent && Object.keys(staticContent).length !== 0) ||
      (dynamicContent && Object.keys(dynamicContent).length !== 0)
    )
  )
    return null;

  return (
    <Box py='3'>
      {/* <ContentText
        content={{
          text:
            dynamicContent?.kicker?.text ||
            combineText(
              staticContent?.kicker?.text,
              dynamicContent.kicker?.inject || []
            ),
        }}
        variant='h4'
      /> */}
      <ContentText
        content={{
          text:
            dynamicContent?.title?.text ||
            combineText(
              staticContent?.title?.text,
              dynamicContent.title?.inject || []
            ),
        }}
        variant='h4'
      />
      <FlexBox
        content={[
          {
            image: staticContent?.images?.[0],
            header:
              dynamicContent?.step1?.title ||
              staticContent?.description?.detailedTexts?.[0].value?.[0],
            description:
              dynamicContent?.step1?.description ||
              combineText(
                staticContent?.description?.detailedTexts?.[0].child?.[0]
                  .value?.[0],
                dynamicContent.step1?.inject || []
              ),
          },
          {
            image: staticContent?.images?.[1],
            header:
              dynamicContent?.step2?.title ||
              staticContent?.description?.detailedTexts?.[1].value?.[0],
            description:
              dynamicContent?.step2?.description ||
              combineText(
                staticContent?.description?.detailedTexts?.[1].child?.[0]
                  .value?.[0],
                dynamicContent.step2?.inject || []
              ),
          },
          {
            image: staticContent?.images?.[2],
            header:
              dynamicContent?.step3?.title ||
              staticContent?.description?.detailedTexts?.[2].value?.[0],
            description:
              dynamicContent?.step3?.description ||
              combineText(
                staticContent?.description?.detailedTexts?.[2].child?.[0]
                  .value?.[0],
                dynamicContent.step3?.inject || []
              ),
          },
        ]}
      />
    </Box>
  );
};

export default Instructions;
